import { render, staticRenderFns } from "./ApiIssue.vue?vue&type=template&id=63c5e502&"
import script from "./ApiIssue.vue?vue&type=script&lang=js&"
export * from "./ApiIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports